<template>
  <div class="popup-box" v-if="show">
    <div class="popup-overlay"></div>
    <div class="popup-body" :style="sizeStyle">
      <div class="popup-header">
        <div class="title">{{ title }}</div>
        <div class="close" title="关闭" @click="cancel" v-if="showClose"></div>
      </div>
      <div class="popup-content">
        <div class="popup-wrap">
          <slot />
        </div>
      </div>
      <div class="popup-footer">
        <div class="btn cancel" @click="cancel" v-if="showClose">
          {{ closeText }}
        </div>
        <div class="btn confirm" @click="confirm" v-if="showConfirm">
          {{ confirmText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '温馨提示',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    closeText: {
      type: String,
      default: '取消',
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    beforeClose: {
      type: Function,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    sizeStyle() {
      let style = {};
      if (this.width) {
        style.width = `${this.width}px`;
      }
      if (this.height) {
        style.height = `${this.height}px`;
      }
      return style;
    },
  },
  watch: {
    visible() {
      this.show = this.visible;
    },
  },
  created() {
    this.show = this.visible;
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.$emit('update:visible', false);
    },
    cancel() {
      this.close();
      this.$emit('cancel');
    },
    async confirm() {
      let data;
      if (typeof this.beforeClose == 'function') {
        try {
          data = await this.beforeClose();
        } catch (e) {
          return;
        }
      }
      this.$emit('confirm', data);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes zoomIn {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.popup-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .popup-overlay {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    animation: fadeIn 0.2s linear forwards;
  }
  .popup-body {
    width: 420px;
    max-width: 95%;
    min-height: 320px;
    background-color: #fff;
    z-index: 1;
    border-radius: 10px;
    box-shadow: 0 0 100px -50px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transform: scale(0);
    animation: zoomIn 0.1s ease-out forwards;
    .popup-header {
      height: 60px;
      max-height: 60px;
      display: flex;
      align-items: center;
      user-select: none;
      background-color: #f8f8f8;
      .title {
        flex: auto;
        text-align: left;
        padding: 0 20px 0 20px;
        font-size: 16px;
        color: #5d5d5d;
      }
      .close {
        width: 60px;
        height: 100%;
        max-width: 60px;
        font-size: 30px;
        font-weight: lighter;
        cursor: pointer;
        position: relative;
        &::before,
        &::after {
          display: inline-block;
          content: '';
          width: 16px;
          background-color: #353535;
          height: 1px;
          transform-origin: 8px 0.5px;
          transform: rotate(45deg);
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
        &::after {
          transform: rotate(-45deg);
        }
      }
    }
    .popup-content {
      flex: auto;
      position: relative;
      .popup-wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        overflow: auto;
        text-align: left;
      }
    }
    .popup-footer {
      height: 50px;
      max-height: 50px;
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 20px;
      .btn {
        display: inline-block;
        font-size: 14px;
        background-color: #fff;
        margin-left: 10px;
        padding: 10px 20px;
        cursor: pointer;
        border-radius: 5px;
        &.cancel {
          background-color: #f5f5f5;
          color: #7b7b7b;
        }
        &.confirm {
          background-color: #99ec73;
          color: #3e9616;
        }
        &:hover {
          filter: brightness(0.9);
          &:active {
            filter: brightness(0.8);
          }
        }
      }
    }
  }
}
</style>